var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8842 5.85039L25.8175 11.7171C26.2175 12.5337 27.2842 13.3171 28.1842 13.4671L33.5008 14.3504C36.9008 14.9171 37.7008 17.3837 35.2508 19.8171L31.1175 23.9504C30.4175 24.6504 30.0342 26.0004 30.2508 26.9671L31.4342 32.0837C32.3675 36.1337 30.2175 37.7004 26.6342 35.5837L21.6508 32.6337C20.7508 32.1004 19.2675 32.1004 18.3508 32.6337L13.3675 35.5837C9.80083 37.7004 7.63416 36.1171 8.56749 32.0837L9.75082 26.9671C9.96749 26.0004 9.58416 24.6504 8.88416 23.9504L4.75082 19.8171C2.31749 17.3837 3.10083 14.9171 6.50083 14.3504L11.8175 13.4671C12.7008 13.3171 13.7675 12.5337 14.1675 11.7171L17.1008 5.85039C18.7008 2.66706 21.3008 2.66706 22.8842 5.85039Z",
    fill: "#FFCA62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStar);
export default __webpack_public_path__ + "static/media/filled-star.2c41381d5bf8926b3077626a0827c84e.svg";
export { ForwardRef as ReactComponent };